import React, { useEffect, useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import ParentOverviewCard from '../../../components/partials/parents/ParentOverviewCard'
import ParentDetails from '../../../components/partials/parents/ParentDetails'
import ParentApplications from '../../../components/partials/parents/ParentApplications'
import ParentStudents from '../../../components/partials/parents/ParentStudents'
import { authHeader, baseUrl } from '../../../utils'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../../store/types'
import Loader from '../../../components/elements/Loader'
import Breadcrumbs from '../../../components/elements/Breadcrumbs'
import { fetchApplications } from '../../../store/actions/applicationsActions';
import { fetchStudents } from '../../../store/actions/studentsActions';

const Parent = () => {
  const breadcrumbsData = [
    {
      label: 'Dashboard',
      path: '/admin/dashboard'
    },
    {
      label: 'Parents',
      path: '/admin/parents'
    },
    {
      label: '',
      path: '',
      current: true
    },
  ]
  
  const { parentId } = useParams()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [parentDetails, setParentDetails] = useState(null)
  // eslint-disable-next-line no-unused-vars
  const [reload, setReload] = useState(0)

  useEffect(() => {
    const fetchParent = async () => {
      try {
        const headers = authHeader()
        const response = await axios.get(`${baseUrl}/parents/${parentId}?expand=students,userProfile,applications`, { headers })
        
        setParentDetails(response.data.data)
        dispatch(fetchApplications(`parent=${parentId}`, 0, 0))
        dispatch(fetchStudents(`parent=${parentId}`, 0, 0))
        setLoading(false)
      } catch (error) {
        console.error(error)
        dispatch({
          type: ERROR,
          error
        })
        setLoading(false)
      }
    }

    fetchParent()

    return () => {}
  }, [parentId, dispatch, reload])
  
  const parentTabs = [
    {
      label: "Personal Details",
      value: 'details'
    },
    {
      label: "Applications",
      value: 'applications'
    },
    {
      label: "Students",
      value: 'students'
    },
  ]

  const [activeTabIndex, setActiveTabIndex] = useState(0)

  const changeTab = (tabIndex) => {
    setActiveTabIndex(tabIndex)
  }

  return (
    <Layout pageTitle={`Parent Profile`}>
      <div className='w-full max-w-[1500px] mx-auto py-6'>
        <Breadcrumbs breadcrumbsData={breadcrumbsData} />
        {loading ? 
          <Loader />
          :
          <div className='mt-6 flex flex-col items-start gap-6 xl:flex-row'>
            <div className='w-full xl:w-[250px] xl:shrink-0 xl:sticky xl:top-[100px]'>
              <ParentOverviewCard parent={parentDetails} />
            </div>
            <div className='w-full'>
              <div className='flex w-full gap-1 overflow-x-auto border-b border-gray-200'>
                {parentTabs.map((tab, tabIndex) => (
                  <button 
                    key={tabIndex} 
                    className={`whitespace-nowrap rounded-t-lg px-4 py-3 text-sm font-medium transition ${activeTabIndex === tabIndex ? 'border-b-2 border-vcm-purple bg-vcm-light-purple/20 text-vcm-purple' : 'text-vcm-dark-gray hover:bg-gray-50 hover:text-vcm-purple'}`}
                    onClick={() => {changeTab(tabIndex)}}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              <div className='pt-5'>
                {parentTabs[activeTabIndex].value === 'details' && (
                  <ParentDetails parent={parentDetails} />
                )}

                {parentTabs[activeTabIndex].value === 'applications' && (
                  <ParentApplications parent={parentDetails} />
                )}

                {parentTabs[activeTabIndex].value === 'students' && (
                  <ParentStudents parent={parentDetails} />
                )}
              </div>
            </div>
          </div>
        }
      </div>
    </Layout>
  )
}

export default Parent
